import * as React from 'react';
export const useOutsideClick = (callback) => {
    const ref = React.useRef(null);
    React.useEffect(() => {
        const handleClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener('click', handleClick, true);
        document.addEventListener('focus', handleClick, true);
        return () => {
            document.removeEventListener('click', handleClick, true);
            document.removeEventListener('focus', handleClick, true);
        };
    }, [ref]);
    return ref;
};
